import { render, staticRenderFns } from "./mail_config.vue?vue&type=template&id=3e11fcd4&scoped=true"
import script from "./mail_config.vue?vue&type=script&lang=js"
export * from "./mail_config.vue?vue&type=script&lang=js"
import style0 from "./mail_config.vue?vue&type=style&index=0&id=3e11fcd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e11fcd4",
  null
  
)

export default component.exports